import { setAgrEnvironment, AgrProcessEnv, AgrEnvironment } from '@next/core-lib/environment';

export class Environment extends AgrEnvironment {
  // add app specific environment variables here
  constructor(env: Environment) {
    super(env);
  }
}

export const setEnvironment = ({
  /* APP_SPECIFIC_ENV, */
  ...env
}: AgrProcessEnv): Environment =>
  new Environment({
    /* APP_SPECIFIC_ENV, */
    /* APP_SPECIFIC_ENV: ..., */
    ...setAgrEnvironment(env),
  });

export const environment = {} as Environment;
